import React, { useState } from "react";
import axios from "axios";
import "./Newsletter.css";
import { showMyAlert } from "../../utils/alertService";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  // Basic email validation
  const validateEmail = (value) => {
    return /^\S+@\S+\.\S+$/.test(value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubscribe = async () => {
    if (!email.trim()) {
      showMyAlert({
        type: "warning",
        title: "Fill Required Fields",
        message: "Please enter an email address.",
        duration: 2500,   
      })
      return;
    }

    if (!validateEmail(email)) {
      showMyAlert({
        type: "warning",
        title: "Validation Error",
        message: "Please enter an valid email address.",
        duration: 2500,   
      })
      return;
    }

    try {
      const response = await axios.post(
        "https://api.dremerz.net/api/Kalanjiyam_User_Subscriptions",
        { email }
      );

      // console.log("Subscription successful:", response.data);

      // Show success modal
      setShowAlert(true);
      setEmail("");

      // Auto hide after 3 sec
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);

    } catch (error) {
      console.error("Error subscribing:", error);
      showMyAlert({
        type: "danger",
        title: "Error",
        message: "Subscription failed. Please try again.",
        duration: 2500,   
      })
    }
  };

  return (
    <div className="newsletter-container container mt-3">
      <div className="d-flex flex-wrap align-items-center">
        
        {/* Text Section */}
        <div className="col-md-6 newsletter-text">
          <h3 className="newsletter-heading">Newsletter</h3>
          <p className="newsletter-subheading">
            Subscribe to get information about products and coupons
          </p>
        </div>

        {/* Input Section */}
        <div className="col-md-6 newsletter-input-container">
          <div className="input-group">
            <input
              type="email"
              className="form-control newsletter-input"
              placeholder="Email address"
              aria-label="Email address"
              value={email}
              onChange={handleEmailChange}
            />

            <button
              className="btn newsletter-button"
              type="button"
              onClick={handleSubscribe}
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>

      {/* Modal Alert */}
      {showAlert && (
        <div
          className="modal show"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)"
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              
              <div className="modal-header">
                <h5 className="modal-title" style={{ color: "#920504" }}>
                  Dear User
                </h5>
              </div>

              <div className="modal-body">
                <p style={{ color: "#920504" }}>Subscribed successfully!</p>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Newsletter;
